export enum LocalesEnum {
  Ru = 'ru',
  En = 'en',
  Us = 'us',
  Es = 'es',
}
